import { buildPathWithMap } from 'authorization';
import { SiteManagmentRoute } from '../domains/site-managment/site-managment.route';
import { AuthenticationRoute } from '../domains/authentication/authentication.route';
import { ThemeRoute } from 'src/domains/theme/theme.route';
import { SchematicsGuiRoute } from 'schematics-gui';
import { UnitsRoute } from 'src/domains/units/units.route';
import { BoothRoute } from 'src/domains/booth/booth.route';
import { ExhibitionSoloRoute } from 'src/domains/exhibition-solo/exhibition-solo.route';
import { CourseRoute } from 'src/domains/course/course.route';
import { IndustrialTourRoute } from 'src/domains/industrial-tour/industrial-tour.route';
import { ExhibitionTourRoute } from 'src/domains/exhibition-tour/exhibition-tour.route';
import { AllProcessRoute } from 'src/domains/all-process/all-process.route';

export class AppRoute {
  static readonly map = {
    root: { ...SiteManagmentRoute.map },
    auth: { ...AuthenticationRoute.map },
    site_managment: { ...SiteManagmentRoute.map },
    theme: { ...ThemeRoute.map },
    exhibition_tour: { ...ExhibitionTourRoute.map },
    booth: { ...BoothRoute.map },
    schematics: { ...SchematicsGuiRoute.map },
    exhibition_solo: { ...ExhibitionSoloRoute.map },
    units: { ...UnitsRoute.map },
    course: { ...CourseRoute.map },
    industrial_tour: { ...IndustrialTourRoute.map },
    all_process: { ...AllProcessRoute.map },
  };
}
export const appRouteIndex = buildPathWithMap(AppRoute.map, '');
